import React from "react";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const fullLabels = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const SessionTimesEditor = ({ event, onEventChange, setUnsavedChanges }) => {

    const { repeat_days } = event;

    const updateRepeatDays = (newRepeatDays) => {
        setUnsavedChanges(true);
        onEventChange({ ...event, repeat_days: newRepeatDays });
    };

    const handleSessionStartTimeChange = (newValue, index) => {
        const dayNumber = parseInt(Object.keys(repeat_days[index])[0], 10);
        const newRepeatDays = [...repeat_days];
        newRepeatDays[index] = { [dayNumber]: newValue };
        updateRepeatDays(newRepeatDays);
    };

    const handleDuplicate = (index) => {
        const dayNumber = parseInt(Object.keys(repeat_days[index])[0], 10);
        const time = repeat_days[index][dayNumber];
        const newRepeatDays = [
            ...repeat_days.slice(0, index + 1),
            { [dayNumber]: time },
            ...repeat_days.slice(index + 1)
        ];
        updateRepeatDays(newRepeatDays);
    };

    const handleDelete = (index) => {
        const newRepeatDays = repeat_days.filter((_, idx) => idx !== index);
        updateRepeatDays(newRepeatDays);
    };

    return (
    <>
      {repeat_days.map((day, index) => {
        const dayNumber = parseInt(Object.keys(day)[0], 10);
        const dayLabel = `${fullLabels[dayNumber]} session`;
        return (
          <div key={`day-${index}`} className="session-time-row">
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <TimePicker
                label={dayLabel}
                value={day[dayNumber] || null}
                onChange={(newValue) => handleSessionStartTimeChange(newValue, index)}
                renderInput={(params) => (
                  <TextField {...params} color="warning" fullWidth size="small" />
                )}
              />
            </LocalizationProvider>
            <IconButton
              aria-label={`Add another ${fullLabels[dayNumber]} session`}
              onClick={() => handleDuplicate(index)}
              size="small">
              <AddCircleOutlineIcon fontSize="small" />
            </IconButton>
            <IconButton
              aria-label={`Remove ${fullLabels[dayNumber]} session`}
              onClick={() => handleDelete(index)}
              size="small">
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          </div>
        );
      })}
    </>
  );
};

SessionTimesEditor.propTypes = {
  event: PropTypes.object,
  onEventChange: PropTypes.func,
  setUnsavedChanges: PropTypes.func,
};

export default SessionTimesEditor;
